interface Props{
    idActa:number;
}
export const EncuestaActa=({idActa}:Props)=>{

    

    return(
        <div className="row">
            <div className="col-md-12">
                    {idActa}
            </div>
        </div>
    )
}